import * as React from "react";
import Link from "next/link";
import { ErrorMessage } from "@nju/form";
import { portalRoutes } from "@nju/routes";
import { A, Button, ButtonsWrapper, Separator } from "@nju/ui";
import { NoFundsButtons } from "../../../shared";

interface IButtonsProps {
  isLoading: boolean;
  isNotEnoughFunds: boolean;
  onSubmit: () => void;
  zeroOfferError: string | undefined;
}

export function Buttons({
  isNotEnoughFunds,
  isLoading,
  onSubmit,
  zeroOfferError,
}: IButtonsProps) {
  const handleOnSubmit = React.useCallback(() => {
    if (!zeroOfferError) {
      onSubmit();
    }
  }, [onSubmit, zeroOfferError]);

  if (isNotEnoughFunds) {
    return <NoFundsButtons />;
  }

  return (
    <div>
      <div>
        {zeroOfferError && (
          <>
            <Separator size="m" tone="invisible" />
            <ErrorMessage message={zeroOfferError} />
            <Separator size="m" tone="invisible" />
          </>
        )}
      </div>
      <ButtonsWrapper>
        <Link
          href={portalRoutes.mojeKonto.index.get({ mode: "mobile" })}
          passHref={true}
        >
          <A size={{ "@onlyMobile": "s" }} variant="secondary">
            anuluj
          </A>
        </Link>
        <Button
          isLoading={isLoading}
          onPress={handleOnSubmit}
          size={{ "@onlyMobile": "s" }}
        >
          dalej
        </Button>
      </ButtonsWrapper>
    </div>
  );
}
